// extracted by mini-css-extract-plugin
export default {"Modal":"Oqyu97dV5XQkG0uVHK6n","Content":"mzYYYVp1usUYe375DBjo","HeadCenter":"GCieLpjOMaur3zXhFcy3","HeadClose":"To9REnnVdQ7p5UoU0Rbl","preview_slide":"xRsNzmYRAzullwI_MDzl","gallpop_fullbox":"ezwBAb32Mz0fxVc2_ATw","gallpop_fullimgbox":"U6BWt4zpvvAYQvAER31d","gallpop_fullimginner":"mDSOlwbVEPbn6IC_mdj_","gallpop_fullimg":"CsbUkUtJ0sDWp9RFzB8T","full_image":"US_yLK956YjG7u059gil","fullnext":"kvFY9_BxgWoCVB9JPL1B","fullprev":"hRWE5wHQhNvEFUa6oXkc"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"Modal\":\"Oqyu97dV5XQkG0uVHK6n\",\"Content\":\"mzYYYVp1usUYe375DBjo\",\"HeadCenter\":\"GCieLpjOMaur3zXhFcy3\",\"HeadClose\":\"To9REnnVdQ7p5UoU0Rbl\",\"preview_slide\":\"xRsNzmYRAzullwI_MDzl\",\"gallpop_fullbox\":\"ezwBAb32Mz0fxVc2_ATw\",\"gallpop_fullimgbox\":\"U6BWt4zpvvAYQvAER31d\",\"gallpop_fullimginner\":\"mDSOlwbVEPbn6IC_mdj_\",\"gallpop_fullimg\":\"CsbUkUtJ0sDWp9RFzB8T\",\"full_image\":\"US_yLK956YjG7u059gil\",\"fullnext\":\"kvFY9_BxgWoCVB9JPL1B\",\"fullprev\":\"hRWE5wHQhNvEFUa6oXkc\"}";
        // 1793707465013
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  